import { Stack, Card, Group, Badge, Text, Grid } from '../../../../components/ui';
import { Box } from '@mantine/core';
import { getStatusColor, getStatusIcon } from '../utils/systemHelpers.tsx';
import type { OverviewTabProps } from '../types';

export function OverviewTab({ healthCheck, systemInfo }: OverviewTabProps) {
  return (
    <Stack gap="md">
      {/* Overall Status Card */}
      {healthCheck && (
        <Card withBorder p="lg">
          <Group justify="space-between">
            <Group gap="md">
              <Box
                style={{
                  padding: '1rem',
                  borderRadius: '50%',
                  backgroundColor: `var(--mantine-color-${getStatusColor(healthCheck.status)}-1)`,
                }}
              >
                {getStatusIcon(healthCheck.status)}
              </Box>
              <Stack gap={4}>
                <Text size="lg" fw={700}>
                  System Status: {healthCheck.status}
                </Text>
                <Text size="sm" c="dimmed">
                  Total check duration: {healthCheck.totalDuration}
                </Text>
              </Stack>
            </Group>
            <Badge size="xl" color={getStatusColor(healthCheck.status)} variant="filled">
              {healthCheck.status}
            </Badge>
          </Group>
        </Card>
      )}

      {/* Quick Stats Grid */}
      {systemInfo && (
        <Grid>
          <Grid.Col span={{ base: 12, sm: 6 }}>
            <Card withBorder>
              <Stack gap={4}>
                <Text size="xs" c="dimmed" tt="uppercase">
                  Environment
                </Text>
                <Badge size="lg" variant="light">
                  {systemInfo.environment}
                </Badge>
              </Stack>
            </Card>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 6 }}>
            <Card withBorder>
              <Stack gap={4}>
                <Text size="xs" c="dimmed" tt="uppercase">
                  Version
                </Text>
                <Text size="sm" fw={600}>
                  {systemInfo.version}
                </Text>
              </Stack>
            </Card>
          </Grid.Col>
        </Grid>
      )}
    </Stack>
  );
}
